import Swiper from "swiper";

class TypesDiplomasSlider {
    constructor(el) {
        this.el = el;
        this.createSlider();
    }

    createSlider() {
        new Swiper(this.el, {
            slidesPerView: "auto",
        });
    }
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-types-diplomas-slider")
        .forEach(slider => new TypesDiplomasSlider(slider));
});
